import filtersStore, {FrameType} from '../filters/filters-store/filters-store';
import priceRangeStore from '../price-range/price-range-store';
import type {ActiveFilterChip} from './list-active-filter-chips';

function isFrameType(value: string): value is FrameType {
    return value === FrameType.Tassel || value === FrameType.Diploma || value === FrameType.Certificate;
}

/** One refresh at the default price range. Other customer selections stay as they are. */
export async function removePriceFilter(): Promise<void> {
    const priceMin = priceRangeStore.min;
    const priceMax = priceRangeStore.max;
    priceRangeStore.replaceRange([priceMin, priceMax]);
    await filtersStore.applyPriceFilter(priceMin, priceMax);
}

export async function removeActiveFilter(chip: ActiveFilterChip): Promise<void> {
    switch (chip.kind) {
        case 'price':
            await removePriceFilter();
            return;
        case 'school':
            await filtersStore.clearSchoolSelection();
            return;
        case 'moulding':
            await filtersStore.finishChanged(false, chip.value);
            return;
        case 'mat':
            await filtersStore.matComboChanged(false, chip.value);
            return;
        case 'frameType':
            if (isFrameType(chip.value)) {
                await filtersStore.removeUserFrameType(chip.value);
            }
            return;
        case 'graduationYear':
            await filtersStore.clearGraduationYearSelection();
            return;
        default:
            return;
    }
}

/**
 * Restores customer filters to the store baseline in one request.
 * Sort is kept. Page returns to 1. Institution, store, best sellers, and prefilter frame types stay.
 */
export function clearActiveFilters(): Promise<number | null> {
    const priceMin = priceRangeStore.min;
    const priceMax = priceRangeStore.max;

    return filtersStore.clearUserFilters(priceMin, priceMax, () => {
        priceRangeStore.replaceRange([priceMin, priceMax]);
    });
}
